import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ToastService } from './toast.services';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-mksoft-toast',
  imports: [NgClass],
  templateUrl: './toast.html',
  styleUrl: './toast.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Toast {
  svc = inject(ToastService);
}
